import { useGenericModal } from '..';
import { LoadAsDraftModal, LoadAsDraftModalProps } from './load-as-draft-modal';

export const useLoadAsDraftModal = (props?: Partial<LoadAsDraftModalProps>) => {
  const { modalRef, openModal, closeModal } = useGenericModal();

  const modalComponent = (
    <LoadAsDraftModal
      testId={props?.testId}
      modalRef={modalRef}
      onClose={closeModal}
    />
  );

  return {
    modalRef,
    openModal,
    closeModal,
    loadAsDraftModal: modalComponent,
  };
};
